export default __webpack_public_path__ + "static/media/yobitzy.e72ab6aa.jpeg";